import { PrefillStoreProps } from "@ctypes";
import { DEFAULT_PREFILL_PROPS, usePrefillStore } from "@stores";

export const usePrefill = () => {
  const { prefillProps, setPrefillProps: setPrefillPropsFromStore } = usePrefillStore();

  const setPrefillProps = (newPrefillProps: PrefillStoreProps) => {
    setPrefillPropsFromStore({
      ...prefillProps,
      ...newPrefillProps,
    });
  };

  const clearPrefillProps = () => {
    setPrefillPropsFromStore(DEFAULT_PREFILL_PROPS);
  };

  const resetPrefillProps = (newPrefillProps: PrefillStoreProps) => {
    setPrefillPropsFromStore(newPrefillProps);
  };

  return {
    prefillProps,
    setPrefillProps,
    clearPrefillProps,
    resetPrefillProps,
  };
};
